// @flow

import { getDotColor, getStatusText } from 'utils/Misc';
export default class OptionList {
  id: string | number;
  text: string;
  image: string;
  status: string;

  constructor(
    id: string | number,
    text: string,
    image: string,
    status: string
  ) {
    this.id = id;
    this.text = text;
    this.image = image;
    this.status = status;
  }

  get value() {
    return this.id;
  }

  set value(val: string) {
    this.id = val;
  }

  get label() {
    return this.text;
  }

  set label(lab: string) {
    this.text = lab;
  }

  get imageShow() {
    return this.image;
  }

  set imageShow(img: string) {
    this.image = img;
  }

  get statusShow() {
    return getStatusText(this.status);
  }

  set statusShow(st: string) {
    this.status = st;
  }

  get statusDot() {
    return getDotColor(this.status);
  }
}
